import { render, staticRenderFns } from "@/components/Layout/Menu/Administracion/Administracion_camiones/Editar_camiones/Editar_camiones.html?vue&type=template&id=48d1da38&scoped=true&"
import script from "@/components/Layout/Menu/Administracion/Administracion_camiones/Editar_camiones/Editar_camiones.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Administracion/Administracion_camiones/Editar_camiones/Editar_camiones.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Administracion/Administracion_camiones/Editar_camiones/Editar_camiones.css?vue&type=style&index=0&id=48d1da38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d1da38",
  null
  
)

export default component.exports